import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { brandColors } from "../../theme";

export const useRawMaterialStyles = makeStyles((theme: Theme) =>
    createStyles({
        backBtn: {
            textTransform: "none",
            marginBottom: theme.spacing(2),
        },
        titleBar: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(4),
        },
        flagText: {
            maxWidth: "650px",
            paddingBottom: theme.spacing(1),
            color: theme.palette.error.main,
        },
        inputSearch: {
            marginRight: theme.spacing(2),
            "& .MuiInput-root": {
                border: `1px solid ${theme.palette.grey[300]}`,
                padding: "2px 8px",
            },
            [theme.breakpoints.down("md")]: {
                width: "200px",
            },
        },
        responsiveTable: {
            minWidth: "425px",
            overflowX: "auto",
        },
        table: {
            "& .MuiTableBody-root .MuiTableRow-root:nth-child(odd)": {
                backgroundColor: theme.palette.grey[50],
            },
            "& .MuiTableCell-root": {
                border: "none",
            },
            "& .MuiTableCell-head": {
                color: "inherit",
                fontSize: "inherit",
                fontWeight: "bold",
                padding: "10px 0px",
            },
            "& .MuiTableRow-head:nth-child(odd)": {
                "& .MuiTableCell-head": {
                    padding: "0px",
                    borderRight: `4px solid ${theme.palette.common.white}`,
                },
            },
            "& .MuiTableCell-body": {
                minWidth: "130px",
                padding: "5px 10px",
            },
        },
        iconDelete: {
            color: brandColors.tertiary.main,
        },
        iconEdit: {
            color: brandColors.tertiary.main,
        },
        mandateSelectorBtn: {
            "&:hover": {
                color: brandColors.primary.main,
            },
        },
        avatar: {
            width: "30px",
            height: "30px",
        },
    })
);

export const useBiofuelReconciliationStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {},
        h2: {
            [theme.breakpoints.down("md")]: {
                fontSize: "32px",
            },
        },
        cardContent: {
            "&.MuiCardContent-root:last-child": {
                paddingBottom: theme.spacing(2),
            },
            "& .MuiOutlinedInput-input": {
                padding: theme.spacing(1, 1.5),
            },
        },
        cardTable: {
            padding: theme.spacing(3),
            paddingRight: theme.spacing(2),
        },
    })
);

export const useBiofuelVolumeStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {},
        h2: {
            [theme.breakpoints.down("md")]: {
                fontSize: "32px",
            },
        },
        btn: {
            width: "170px",
            padding: "13px 0",
            lineHeight: "14px",
            "&:not(:first-child)": {
                marginLeft: "20px",
            },
            [theme.breakpoints.down("md")]: {
                width: "130px",
                padding: "12px 0 9px 0",
                "&:not(:first-child)": {
                    marginLeft: "10px",
                },
            },
        },
        toggleContainer: {
            marginTop: theme.spacing(3),
        },
        topCard: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(2),
            backgroundColor: theme.palette.background.paper,
            borderRadius: 4,
            boxShadow: "-10px 10px 20px 0 rgba(30, 30, 30, 0.05)",
            padding: theme.spacing(2),
        },
        cardContent: {
            "&.MuiCardContent-root:last-child": {
                paddingBottom: theme.spacing(2),
            },
            "& .MuiOutlinedInput-input": {
                padding: theme.spacing(1, 1.5),
            },
        },
        cardTable: {
            padding: theme.spacing(3),
            paddingRight: theme.spacing(2),
        },
        fields: {
            position: "relative",
            "& .MuiFormHelperText-root.Mui-error": {
                position: "absolute",
                bottom: theme.spacing(-1.6),
                whiteSpace: "nowrap",
            },
            "& .MuiFormHelperText-contained": {
                margin: 0,
            },
        },
    })
);
